import { configureStore } from './store';
export * from './RootReducer';

export const { store, persistor } = configureStore();
